import * as fs from 'node:fs';
import * as path from 'node:path';
import type { IsolatedWorktreeBinding } from '../isolated-worktree-binding.js';
import { collectGitRepoRootsUnderDirectory } from './collect-worktree-paths.js';

export async function tryBindingFromIsolatedDirectory(
  scopeDir: string,
): Promise<IsolatedWorktreeBinding | null> {
  let st: fs.Stats;
  try {
    st = await fs.promises.stat(scopeDir);
  } catch {
    return null;
  }
  if (!st.isDirectory()) return null;
  const { paths: worktreePaths } = await collectGitRepoRootsUnderDirectory(scopeDir);
  if (worktreePaths.length === 0) return null;
  const abs = path.resolve(scopeDir);
  return {
    parentPath: abs,
    repoCheckoutPaths: worktreePaths,
  };
}
